<template>
  <div class="flex flex-col gap-2 mt-3">
    <div class="inline-flex gap-2 justify-left md:justify-center">
      <Icon name="fa6-brands:cc-paypal" size="35px" />
      <Icon name="fa6-brands:cc-visa" size="35px" />
      <Icon name="fa6-brands:cc-mastercard" size="35px" />
    </div>
    <div class="inline-flex gap-2 justify-left md:justify-center">
      <Icon name="fa6-brands:dhl" size="40px" />
      <Icon name="fa6-brands:fedex" size="40px" />
    </div>
  </div>
</template>